// Diagnostics only in development; silent in production builds.
export const warn = (...args) => {
  if (process.env.NODE_ENV === "development") console.warn(...args);
};
